export default "__VITE_ASSET__4o2y3JiW__"